<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
<!--            <FormItem label="广告名称："  label-for="key">-->
<!--              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">-->
<!--              </Input>-->
<!--            </FormItem>-->
          </Col>
        </Row>
        <Row type="flex">
          <Col>
<!--            <Button type="primary"  icon="md-add" @click="add">添加广告</Button>-->
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="formInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="pic_url">
          <div class="tabBox_img">
            <img :src="row.pic_url ? row.pic_url : ''">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.advert_id)">编辑</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!-- 添加编辑-->
    <picEdit :editShow="editShow" :id="advert_id" @updateStatusModel="updateStatusModel"></picEdit>
  </div>
</template>

<script>
import { advertList2 } from '@/api/advert'
import picEdit from './components/picEdit'
export default {
  name: 'singlePic',
  components: { picEdit },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: ''
      },
      editShow: false,
      dataCount: 0,
      formInfo: [],
      loading: false,
      advert_id: 0,
      ids: 0,
      columns2: [
        {
          title: 'ID',
          key: 'advert_id',
          minWidth: 50
        },
        {
          title: '广告名称',
          key: 'advert_name',
          minWidth: 120
        },
        {
          title: '广告图片',
          slot: 'pic_url',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.advertList()
  },
  methods: {
    advertList () {
      this.loading = true
      advertList2(this.userForm).then(res => {
        let data = res.data
        this.formInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.advertList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.advertList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.advert_id = id
      this.editShow = true
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    // 添加
    add () {
      this.editShow = true
    },
  }
}
</script>
